// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__30MRu","modalTitle":"Modal_modalTitle__1-C3X"};